var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComputer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 356,
    height: 200,
    viewBox: "0 0 356 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Computer"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1",
    width: 355.789,
    height: 200,
    rx: 5,
    fill: "#DCDFE4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ImgWithText"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TextLine"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15",
    x: 112,
    y: 154,
    width: 11,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14",
    x: 112,
    y: 154,
    width: 11,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_2",
    x: 83,
    y: 160,
    width: 4,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_2",
    x: 83,
    y: 160,
    width: 4,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_3",
    x: 83,
    y: 166,
    width: 10,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_3",
    x: 83,
    y: 166,
    width: 10,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Image"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 13",
    x: 83,
    y: 146,
    width: 40,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 83,
    y: 118,
    width: 40,
    height: 30
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 12",
    x: 83,
    y: 118,
    width: 40,
    height: 30,
    rx: 1,
    fill: "#555555"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 10",
    x: 67.2132,
    y: 153.929,
    width: 33.8406,
    height: 33.8406,
    rx: 1,
    transform: "rotate(-45 67.2132 153.929)",
    fill: "#282C34"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 11",
    x: 87,
    y: 149.929,
    width: 33.8406,
    height: 33.8406,
    rx: 1,
    transform: "rotate(-45 87 149.929)",
    fill: "#282C34"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 9",
    x: 83.5,
    y: 118.5,
    width: 39,
    height: 29,
    rx: 0.5,
    stroke: "#282C34"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_4",
    x: 83,
    y: 154,
    width: 9,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_4",
    x: 83,
    y: 154,
    width: 9,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_5",
    x: 94,
    y: 154,
    width: 16,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_5",
    x: 94,
    y: 154,
    width: 16,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_6",
    x: 89,
    y: 160,
    width: 17,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_6",
    x: 89,
    y: 160,
    width: 17,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_7",
    x: 108,
    y: 160,
    width: 4,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_7",
    x: 108,
    y: 160,
    width: 4,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_8",
    x: 114,
    y: 160,
    width: 9,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_8",
    x: 114,
    y: 160,
    width: 9,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_9",
    x: 95,
    y: 166,
    width: 15,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_9",
    x: 95,
    y: 166,
    width: 15,
    height: 2,
    rx: 1,
    fill: "#282C34"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ImgWithText_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TextLine_10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_10",
    x: 162,
    y: 154,
    width: 11,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_10",
    x: 162,
    y: 154,
    width: 11,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_11",
    x: 133,
    y: 160,
    width: 4,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_11",
    x: 133,
    y: 160,
    width: 4,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_12",
    x: 133,
    y: 166,
    width: 10,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_12",
    x: 133,
    y: 166,
    width: 10,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Image_2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 13_2",
    x: 133,
    y: 146,
    width: 40,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 133,
    y: 118,
    width: 40,
    height: 30
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 12_2",
    x: 133,
    y: 118,
    width: 40,
    height: 30,
    rx: 1,
    fill: "#555555"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 10_2",
    x: 117.213,
    y: 153.929,
    width: 33.8406,
    height: 33.8406,
    rx: 1,
    transform: "rotate(-45 117.213 153.929)",
    fill: "#282C34"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 11_2",
    x: 137,
    y: 149.929,
    width: 33.8406,
    height: 33.8406,
    rx: 1,
    transform: "rotate(-45 137 149.929)",
    fill: "#282C34"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 9_2",
    x: 133.5,
    y: 118.5,
    width: 39,
    height: 29,
    rx: 0.5,
    stroke: "#282C34"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_13",
    x: 133,
    y: 154,
    width: 9,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_13",
    x: 133,
    y: 154,
    width: 9,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_14",
    x: 144,
    y: 154,
    width: 16,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_14",
    x: 144,
    y: 154,
    width: 16,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_15",
    x: 139,
    y: 160,
    width: 17,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_15",
    x: 139,
    y: 160,
    width: 17,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_16",
    x: 158,
    y: 160,
    width: 4,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_16",
    x: 158,
    y: 160,
    width: 4,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_17",
    x: 164,
    y: 160,
    width: 9,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_17",
    x: 164,
    y: 160,
    width: 9,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_18",
    x: 145,
    y: 166,
    width: 15,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_18",
    x: 145,
    y: 166,
    width: 15,
    height: 2,
    rx: 1,
    fill: "#282C34"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ImgWithText_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TextLine_19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_19",
    x: 212,
    y: 154,
    width: 11,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_19",
    x: 212,
    y: 154,
    width: 11,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_20",
    x: 183,
    y: 160,
    width: 4,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_20",
    x: 183,
    y: 160,
    width: 4,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_21",
    x: 183,
    y: 166,
    width: 10,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_21",
    x: 183,
    y: 166,
    width: 10,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Image_3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 13_3",
    x: 183,
    y: 146,
    width: 40,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 183,
    y: 118,
    width: 40,
    height: 30
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 12_3",
    x: 183,
    y: 118,
    width: 40,
    height: 30,
    rx: 1,
    fill: "#555555"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 10_3",
    x: 167.213,
    y: 153.929,
    width: 33.8406,
    height: 33.8406,
    rx: 1,
    transform: "rotate(-45 167.213 153.929)",
    fill: "#282C34"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 11_3",
    x: 187,
    y: 149.929,
    width: 33.8406,
    height: 33.8406,
    rx: 1,
    transform: "rotate(-45 187 149.929)",
    fill: "#282C34"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 9_3",
    x: 183.5,
    y: 118.5,
    width: 39,
    height: 29,
    rx: 0.5,
    stroke: "#282C34"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_22",
    x: 183,
    y: 154,
    width: 9,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_22",
    x: 183,
    y: 154,
    width: 9,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_23",
    x: 194,
    y: 154,
    width: 16,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_23",
    x: 194,
    y: 154,
    width: 16,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_24",
    x: 189,
    y: 160,
    width: 17,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_24",
    x: 189,
    y: 160,
    width: 17,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_25",
    x: 208,
    y: 160,
    width: 4,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_25",
    x: 208,
    y: 160,
    width: 4,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_26",
    x: 214,
    y: 160,
    width: 9,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_26",
    x: 214,
    y: 160,
    width: 9,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_27"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_27",
    x: 195,
    y: 166,
    width: 15,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_27",
    x: 195,
    y: 166,
    width: 15,
    height: 2,
    rx: 1,
    fill: "#282C34"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ImgWithText_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TextLine_28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_28",
    x: 262,
    y: 154,
    width: 11,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_28",
    x: 262,
    y: 154,
    width: 11,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_29",
    x: 233,
    y: 160,
    width: 4,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_29",
    x: 233,
    y: 160,
    width: 4,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_30",
    x: 233,
    y: 166,
    width: 10,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_30",
    x: 233,
    y: 166,
    width: 10,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Image_4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 13_4",
    x: 233,
    y: 146,
    width: 40,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 233,
    y: 118,
    width: 40,
    height: 30
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 12_4",
    x: 233,
    y: 118,
    width: 40,
    height: 30,
    rx: 1,
    fill: "#555555"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 10_4",
    x: 217.213,
    y: 153.929,
    width: 33.8406,
    height: 33.8406,
    rx: 1,
    transform: "rotate(-45 217.213 153.929)",
    fill: "#282C34"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 11_4",
    x: 237,
    y: 149.929,
    width: 33.8406,
    height: 33.8406,
    rx: 1,
    transform: "rotate(-45 237 149.929)",
    fill: "#282C34"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 9_4",
    x: 233.5,
    y: 118.5,
    width: 39,
    height: 29,
    rx: 0.5,
    stroke: "#282C34"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_31"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_31",
    x: 233,
    y: 154,
    width: 9,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_31",
    x: 233,
    y: 154,
    width: 9,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_32",
    x: 244,
    y: 154,
    width: 16,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_32",
    x: 244,
    y: 154,
    width: 16,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_33"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_33",
    x: 239,
    y: 160,
    width: 17,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_33",
    x: 239,
    y: 160,
    width: 17,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_34"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_34",
    x: 258,
    y: 160,
    width: 4,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_34",
    x: 258,
    y: 160,
    width: 4,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_35"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_35",
    x: 264,
    y: 160,
    width: 9,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_35",
    x: 264,
    y: 160,
    width: 9,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_36"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_36",
    x: 245,
    y: 166,
    width: 15,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_36",
    x: 245,
    y: 166,
    width: 15,
    height: 2,
    rx: 1,
    fill: "#282C34"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_37"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_37",
    x: 183,
    y: 48,
    width: 22,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_37",
    x: 183,
    y: 48,
    width: 22,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_38"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_38",
    x: 207,
    y: 48,
    width: 14,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_38",
    x: 207,
    y: 48,
    width: 14,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_39"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_39",
    x: 223,
    y: 48,
    width: 5,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_39",
    x: 223,
    y: 48,
    width: 5,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_40"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_40",
    x: 230,
    y: 48,
    width: 17,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_40",
    x: 230,
    y: 48,
    width: 17,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_41"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_41",
    x: 249,
    y: 48,
    width: 20,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_41",
    x: 249,
    y: 48,
    width: 20,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_42"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_42",
    x: 183,
    y: 42,
    width: 25,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_42",
    x: 183,
    y: 42,
    width: 25,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_43"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_43",
    x: 210,
    y: 42,
    width: 6,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_43",
    x: 210,
    y: 42,
    width: 6,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_44"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_44",
    x: 218,
    y: 42,
    width: 11,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_44",
    x: 218,
    y: 42,
    width: 11,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_45"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_45",
    x: 231,
    y: 42,
    width: 30,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_45",
    x: 231,
    y: 42,
    width: 30,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_46"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_46",
    x: 183,
    y: 36,
    width: 18,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_46",
    x: 183,
    y: 36,
    width: 18,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_47"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_47",
    x: 203,
    y: 36,
    width: 9,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_47",
    x: 203,
    y: 36,
    width: 9,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_48"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_48",
    x: 214,
    y: 36,
    width: 24,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_48",
    x: 214,
    y: 36,
    width: 24,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_49"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_49",
    x: 240,
    y: 36,
    width: 33,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_49",
    x: 240,
    y: 36,
    width: 33,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_50"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_50",
    x: 183,
    y: 54,
    width: 6,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_50",
    x: 183,
    y: 54,
    width: 6,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_51"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_51",
    x: 191,
    y: 54,
    width: 15,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_51",
    x: 191,
    y: 54,
    width: 15,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_52"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_52",
    x: 208,
    y: 54,
    width: 29,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_52",
    x: 208,
    y: 54,
    width: 29,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_53"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_53",
    x: 239,
    y: 54,
    width: 25,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_53",
    x: 239,
    y: 54,
    width: 25,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_54"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_54",
    x: 183,
    y: 60,
    width: 20,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_54",
    x: 183,
    y: 60,
    width: 20,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_55"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_55",
    x: 205,
    y: 60,
    width: 23,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_55",
    x: 205,
    y: 60,
    width: 23,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_56"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_56",
    x: 230,
    y: 60,
    width: 16,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_56",
    x: 230,
    y: 60,
    width: 16,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_57"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_57",
    x: 248,
    y: 60,
    width: 25,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_57",
    x: 248,
    y: 60,
    width: 25,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_58"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_58",
    x: 183,
    y: 66,
    width: 4,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_58",
    x: 183,
    y: 66,
    width: 4,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TextLine_59"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_59",
    x: 189,
    y: 66,
    width: 10,
    height: 3,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_59",
    x: 189,
    y: 66,
    width: 10,
    height: 2,
    rx: 1,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Image_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1_5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 83,
    y: 26,
    width: 90,
    height: 68
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 12_5",
    x: 83,
    y: 26,
    width: 90,
    height: 67.9702,
    rx: 1,
    fill: "#555555"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 10_5",
    width: 76.407,
    height: 76.407,
    rx: 1,
    transform: "matrix(0.704649 -0.709556 0.704649 0.709556 47.4797 107.403)",
    fill: "#282C34"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 11_5",
    width: 76.407,
    height: 76.407,
    rx: 1,
    transform: "matrix(0.704648 -0.709557 0.704648 0.709557 92 98.3405)",
    fill: "#282C34"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 9_5",
    x: 83.5,
    y: 26.5,
    width: 89,
    height: 66.9702,
    rx: 0.5,
    stroke: "#282C34"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 13_5",
    x: 83,
    y: 91.9403,
    width: 90,
    height: 3.08955,
    rx: 1,
    fill: "#282C34",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Button"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 17",
    x: 183,
    y: 79,
    width: 30,
    height: 8,
    rx: 2,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 16",
    x: 183,
    y: 79,
    width: 30,
    height: 7,
    rx: 2,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "HeadLine"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_60",
    x: 183,
    y: 26,
    width: 15,
    height: 7,
    rx: 3,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_60",
    x: 183,
    y: 26,
    width: 15,
    height: 6,
    rx: 3,
    fill: "#282C34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "HeadLine_2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15_61",
    x: 200,
    y: 26,
    width: 28,
    height: 7,
    rx: 3,
    fill: "#282C34",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_61",
    x: 200,
    y: 26,
    width: 28,
    height: 6,
    rx: 3,
    fill: "#282C34"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.ba55b973926c3c2bf8ef2b7a37a3927b.svg";
export { ForwardRef as ReactComponent };